// JavaScript announcement  bar cookie
$(document).ready(function ($) {
  // Set cookie bar to fully visible
  $(".cookie-bar").css("opacity", "1");
  // Calculate expiration time for the cookie (30 days)
  var now = new Date();
  var time = now.getTime();
  var expireTime = time + 1 * 24 * 60 * 60 * 1000;
  now.setTime(expireTime);

  // Check if the cookie AnnouncementBar=true exists
  if (document.cookie.indexOf("AnnouncementBar=true") < 0) {
    // If not, attach click event handler to the cookie button
    $("#cookie-button").click(function () {
      // Set the cookie
      document.cookie =
        "AnnouncementBar=true; expires=" +
        now.toGMTString() +
        ";path={{ " / " | append: ' ' }}";
    });
  } else {
    // If the cookie exists, remove the cookie bar
    $(".cookie-bar").remove();
  }

  // Attach click event handler to the cookie button to hide the cookie bar
  $("#cookie-button").click(function () {
    // Hide the cookie bar
    $(this).closest(".cookie-bar").hide();

    // Remove the cookie bar after a delay
    var _this = $(this);
    setTimeout(function () {
      _this.closest(".cookie-bar").remove();
    }, 100);
  });
});

// JavaScript footer accordions
$(document).ready(function () {
  $(".ft-Footer_AccordionButton").click(function () {
    var $accordionBody = $(this).next(".ft-Footer_AccordionBody");
    var $accordionIconPlus = $(this).find(".ft-Footer_AccordionIcon-plus");
    var $accordionIconMinus = $(this).find(".ft-Footer_AccordionIcon-minus");
    var isActive = $(this).attr("aria-expanded") === "true";

    if (isActive) {
      $accordionBody.slideUp("slow");
      $(this).attr("aria-expanded", "false");
      $accordionIconPlus.show();
      $accordionIconMinus.hide();
      $("body").removeClass("acc-open"); // Remove the class when accordion is closed
    } else {
      $(".ft-Footer_AccordionBody").slideUp("slow");
      $(".ft-Footer_AccordionButton").attr("aria-expanded", "false");
      $(".ft-Footer_AccordionIcon-plus").show();
      $(".ft-Footer_AccordionIcon-minus").hide();

      $accordionBody.slideDown("slow");
      $(this).attr("aria-expanded", "true");
      $accordionIconPlus.hide();
      $accordionIconMinus.show();
      $("body").addClass("acc-open"); // Add the class when accordion is opened
    }
  });
});

// JavaScript to open and close the footer newsletter popup
//   const openButton = document.getElementById('openNewsPopup');
//   const closeButton = document.getElementById('closeNewsPopup');
//   const popup = document.getElementById('footer-newsletter-popup');
//   openButton.addEventListener('click', function() {
//     popup.style.display = 'block';
//   });
//   closeButton.addEventListener('click', function() {
//     popup.style.display = 'none';
//   });

// JavaScript to open and close the footer contact popup
const openButton2 = document.getElementById("openContactPopup");
const closeButton2 = document.getElementById("closeContactPopupbtn");
const popup2 = document.getElementById("footer-contact-popup");
const backdrop2 = document.getElementById("closeContactPopup"); // Adjusted to match backdrop ID
const body = document.body;

openButton2.addEventListener("click", function () {
  popup2.style.display = "block";
  body.classList.add("unset-clip-path"); // Add class to body when popup opens
});

closeButton2.addEventListener("click", function (event) {
  event.stopPropagation();
  popup2.style.display = "none"; // Close popup directly when close button is clicked
  body.classList.remove("unset-clip-path"); // Remove class from body when popup closes
});

backdrop2.addEventListener("click", function (event) {
  event.stopPropagation();
  popup2.style.display = "none";
  body.classList.remove("unset-clip-path");
});

// Delayed click event based on the URL
setTimeout(function () {
  // Check if the current URL contains the specified URL
  if (window.location.href.includes("?contact_posted=true#contact_form")) {
    // Find the button element with the id "btn-sold" and trigger a click event
    var btnSold = $("#openContactPopup");
    if (btnSold.length) {
      btnSold.click();
    }
  }
}, 1000); // Replace 1000 with the desired delay in milliseconds

// // Adjusted backdrop event listener to close popup when clicked outside
// body.addEventListener('click', function(event) {
//   if (!popup2.contains(event.target) && event.target !== openButton2) {
//     popup2.style.display = 'none';
//     body.classList.remove('unset-clip-path'); // Remove class from body when backdrop is clicked
//   }
// });

//Open links in new tab
$(document).ready(function () {
  // Select all links with href attribute starting with "http" or "//"
  $('a[href^="http"], a[href^="//"]').each(function () {
    // Check if the link's host is different from the current host
    if (this.hostname && this.hostname !== window.location.hostname) {
      $(this).attr("target", "_blank"); // Open link in new tab
    }
  });
});

//banner animation for scaling
const myElements = document.querySelectorAll(
  ".sec-FullScreenMedia_MediaContainer"
);
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      myElements.forEach((element) => {
        element.classList.add("visible");
        element.classList.remove("scale-down");
      });
    } else {
      myElements.forEach((element) => {
        element.classList.remove("visible"), 3000;
        element.classList.add("scale-down");
      });
    }
  });
});
myElements.forEach((element) => {
  observer.observe(element);
});

// //Open header menus drawer hover
// jQuery(document).ready(function($) {
//   // Function to handle header interactions
//   function handleHeaderInteraction() {
//     var windowWidth = $(window).width();
//     // Only execute if the window width is greater than 989 pixels
//     if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && windowWidth > 989) {
//       // Open the sidebar menu when hovering over the primary navigation
//       $(".header__primary-nav").mouseenter(function() {
//         $(".header__primary-nav button").trigger('click');
//       });

//       // Close the sidebar menu when mouse leaves sidebar content or overlay
//       $(".header-sidebar-content, .cs-overlay-drawer").mouseleave(function() {
//         closeSidebarMenu();
//       });

//       // Close the sidebar menu when mouse enters overlay
//       $(".cs-overlay-drawer").mouseenter(function() {
//         closeSidebarMenu();
//       });
//     }
//   }

//   // Function to close the sidebar menu
//   function closeSidebarMenu() {
//     $(".header-sidebar-close").trigger("click");
//     $('#sidebar-menu').hide().removeAttr('open');
//   }

//   // Call the function on document ready
//   handleHeaderInteraction();

//   // Call the function on window resize
//   $(window).resize(function() {
//     handleHeaderInteraction();
//   });
// });

//Mobile size + complete look
$(document).ready(function () {
  // Hide sizes-popup by default
  $("#sizes-popup").hide();
  $(".btn_mobb_cm").click(function () {
    $("#sizes-popup").slideToggle();
  });
});

//Mobile size + coll cards products
$(document).ready(function () {
  $("body").on("click", ".btn_mobb", function () {
    var $popup = $(this).closest(".product-card").find(".mob-sizes-popup");
    $popup.slideToggle();
  });
});

//Mobile size + recently view products
$(document).ready(function () {
  $("body").on("click", ".btn_mobb_gf", function () {
    var $popup_link = $(this)
      .closest(".cs-gl-card-pro")
      .find(".mob-sizes-popup_gf");
    $popup_link.slideToggle();
  });
});

/* header menu colour class  */
document.addEventListener("DOMContentLoaded", function () {
  var buttonsWithAriaControls = document.querySelectorAll("[aria-controls]");
  buttonsWithAriaControls.forEach(function (button) {
    var controlId = button.getAttribute("aria-controls");
    var controlledElement = document.getElementById(controlId);
    if (controlledElement && button.closest(".accent-color")) {
      controlledElement.classList.add("accent-color");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Tab buttons
  const tabLinks = document.querySelectorAll(".tab-link");

  // Initialize Slick Slider for all carousels
  function initializeSlickSlider() {
    document
      .querySelectorAll(".product-carousel-items")
      .forEach(function (carousel) {
        $(carousel).slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      });
  }

  // Function to handle tab switching
  tabLinks.forEach(function (tab) {
    tab.addEventListener("click", function () {
      // Hide all product carousels
      document
        .querySelectorAll(".product-carousel")
        .forEach(function (carousel) {
          carousel.style.display = "none";
        });

      // Remove 'active' class from all tabs
      tabLinks.forEach(function (tab) {
        tab.classList.remove("active");
      });

      // Show the selected collection's product carousel
      const collectionId = tab.getAttribute("data-collection-id");
      const selectedCarousel = document.querySelector("." + collectionId);
      selectedCarousel.style.display = "block";

      // Add 'active' class to the clicked tab
      tab.classList.add("active");

      // Reinitialize Slick Slider when a tab is clicked
      $(selectedCarousel).find(".product-carousel-items").slick("refresh");
    });
  });

  // Optional: Auto click the first tab on page load to show first collection
  if (tabLinks.length > 0) {
    tabLinks[0].click();
  }

  // Initialize Slick Slider on page load
  initializeSlickSlider();
});

function updateViewAllUrl(collectionUrl) {
  // "View All" button ko select karna
  var viewAllBtn = document.getElementById("view-all-btn");

  // URL ko update karna
  if (viewAllBtn) {
    viewAllBtn.href = collectionUrl;
  }
}

/* Custom checkout button */
document.querySelector("[data-buy-now]").addEventListener("click", () => {
  let addToCartForm = document.querySelector('form[action$="/cart/add"]');
  let formData = new FormData(addToCartForm);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      window.location.href = "/checkout";
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});



/****For Product Page Show Next Day Delivery*****/
document.addEventListener("DOMContentLoaded", function () {
    const nextDay = document.getElementById("next-day-delivery-message");

    function updateNextDayVisibility() {
      const preorderText = document.querySelector(".timesact-preorder-description");
      const isVisible = preorderText && preorderText.offsetParent !== null;

      if (isVisible) {
        nextDay.style.display = "none";
      } else {
        nextDay.style.display = "block";
      }
    }

    function watchPreorderChange() {
      let attempt = 0;
      const interval = setInterval(() => {
        updateNextDayVisibility();
        attempt++;
        if (attempt > 40) clearInterval(interval); // max ~8 seconds
      }, 200);
    }

    // Run on initial load
    watchPreorderChange();

    // Watch variant buttons or selectors
    document.querySelectorAll('input[type="radio"], select').forEach((el) => {
      el.addEventListener("change", () => {
        setTimeout(() => {
          watchPreorderChange();
        }, 150);
      });
    });

    // Support themes firing custom variant events
    document.addEventListener("variant:changed", () => {
      setTimeout(() => {
        watchPreorderChange();
      }, 150);
    });

    // Some Timesact widgets update via mutation (dynamic DOM changes)
    const observer = new MutationObserver(() => {
      updateNextDayVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });


// function addToCart(variantId) {
//   var quantity = 1; // Set quantity based on your needs
  
//   var data = {
//     items: [{
//       id: variantId,
//       quantity: quantity
//     }]
//   };

//   // Make an AJAX request to add the item to the cart
//   fetch('/cart/add.js', {
//     method: 'POST',
//     body: JSON.stringify(data),
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
//   .then(response => response.json())
//   .then(data => {
//     console.log('Item added to cart', data);

//     // Trigger Cartix to update the cart drawer
//     if (typeof Cartix !== 'undefined' && typeof Cartix.updateCart === 'function') {
//       Cartix.updateCart(data); // Update Cartix cart drawer
//     }

//     // Manually open the cart drawer if Cartix is loaded
//     if (typeof Cartix !== 'undefined' && typeof Cartix.openDrawer === 'function') {
//       Cartix.openDrawer(); // Open the drawer
//     }
//   })
//   .catch(error => {
//     console.error('Error adding item to cart:', error);
//   });
// }

function checkAndAddToCart(button) {
  var variantId = button.getAttribute('data-variant-id');
  var isAvailable = button.getAttribute('data-available') === 'true';

  if (!isAvailable) {
    alert('This product is sold out and cannot be added to the cart.');
    return;
  }

  addToCart(variantId);
}

function addToCart(variantId) {
  var quantity = 1;

  var data = {
    items: [{
      id: variantId,
      quantity: quantity
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422) {
      alert('This product is sold out and cannot be added to the cart.');
      console.log(data.message);
      return;
    }

    console.log('Item added to cart', data);

    updateCartPage();

    // Open Cartix drawer
    if (typeof window.CD_OPENCART === 'function') {
      window.CD_OPENCART();

      if (typeof window.CD_UPDATECART === 'function') {
        window.CD_UPDATECART();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } else {
      console.warn('Cartix drawer function not ready yet.');
    }
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}

function updateCartPage() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = data.item_count;
      }

      var cartTotal = document.querySelector('.cart-total');
      if (cartTotal) {
        cartTotal.textContent = Shopify.formatMoney(data.total_price, Shopify.money_format);
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}